import { useCallback } from "react";

import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { useAppDispatch } from "app/hooks";
import { neutral } from "app/themes/colors";

import { createLogger } from "../../logging.util";
import { toggleShowDeviceSettingsDialog } from "../../medical-scribe.slice";

export default function DeviceSettingsButton() {
  const dispatch = useAppDispatch();

  const handleDeviceAccess = useCallback(
    async (event: React.MouseEvent | React.TouchEvent) => {
      event.stopPropagation();

      try {
        // Request microphone access
        await navigator.mediaDevices.getUserMedia({ audio: true });
        const devices = await navigator.mediaDevices.enumerateDevices();
        createLogger.log(
          `Available devices: ${devices.length} device(s) found`,
          null
        );

        dispatch(toggleShowDeviceSettingsDialog());
      } catch (error) {
        createLogger.error("Error accessing microphone:", error, null);
      }
    },
    [dispatch]
  );

  return (
    <Tooltip title="Audio Device Settings" disableInteractive>
      <IconButton
        size="small"
        sx={{
          p: 0,
          transform: "scale(1)",
          color: "white",
          "&:hover": {
            color: neutral[400]
          }
        }}
        onClick={handleDeviceAccess}
        onTouchEnd={handleDeviceAccess}
      >
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  );
}
